import React, { useEffect, useState } from "react";
import sha256 from "js-sha256";
import axios from "axios";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "./Spinner";
import OverlayLoader from "../modalPopups/overlayLoader";

export default function OrderSection(props) {
  const navigate = useNavigate();

  const apiOrderUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/orders`;

  const hash = sha256(props.searchterm);
  const accessToken = localStorage.getItem("accessToken");

  let orderUrl = `${apiOrderUrl}?hash=${hash}&includeProduct=true`;
  let totalPurchase = 0.0;

  const [orderData, setorderData] = useState(null);
  const [dataCount, setDataCount] = useState(0);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [overLayPopupShow, setOverLayPopupShow] = useState(false);
  const [overLayPopupText, setOverLayPopupText] = useState("");

  const handleOverylayModalShowClose = (modalStatus, modalText) => {
    setOverLayPopupShow(modalStatus);
    setOverLayPopupText(modalText);
  };

  const fetchUrl = (URl) => {
    axios
      .get(URl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((result) => {
        //console.log("result=="+result.data.data.length)
        setIsLoading(false);
        handleOverylayModalShowClose(false, "");
        if (result.data.status === "success") {
          setorderData(result.data.data);
          setDataCount(result.data.data.length);
          setError(null);
        }
      })
      .catch((error) => {
        // Error
        handleOverylayModalShowClose(false, "");
        setError(error.message);
        setorderData();
        if (error.response.status === 401) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };

  useEffect(() => {
    setIsLoading(true);
    handleOverylayModalShowClose(true, "Orders Data Loading... Please Wait");
    fetchUrl(orderUrl); // eslint-disable-next-line
    setorderData(); // eslint-disable-next-line
  }, [props.getDate]);

  return (
    <>
      <div className="app-wrapper">
        <div className="app-content pt-3 p-md-3 p-lg-4">
          <div className="container-xl">
            <OverlayLoader
              show={overLayPopupShow}
              title=""
              body={overLayPopupText}
            />

            <div className="app-content pt-3 mb-5">
              {props.searchterm ? (
                <h3>
                  Search: <code>{props.searchterm}</code>
                </h3>
              ) : (
                <h3>There is no name in the query string</h3>
              )}
            </div>

            {error && (
              <div className="w-50 mx-auto alert alert-danger fade show">{`There is a problem fetching the Order data - ${error}`}</div>
            )}

            <div className="row g-3 mb-4 align-items-center justify-content-between">
              <div className="col-auto">
                <h1 className="app-page-title mb-0">
                  Orders <span>({dataCount})</span>
                </h1>
              </div>
            </div>

            <div className="tab-content" id="orders-table-tab-content">
              <div
                className="tab-pane fade show active"
                id="orders-all"
                role="tabpanel"
                aria-labelledby="orders-all-tab"
              >
                <div className="app-card app-card-orders-table shadow-sm mb-5">
                  <div className="app-card-body">
                    <div className="table-responsive">
                      <table className="table table-hover table-bordered border-success">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Price (USD)</th>
                            <th>Tag</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Options</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <tr>
                              <td colSpan={7}>
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {orderData &&
                            orderData.map((order, i) => {
                              totalPurchase =
                                parseFloat(totalPurchase) +
                                parseFloat(order.productInfo.price);

                              var formattedOrderDate = format(
                                new Date(order.orderDate),
                                "MMM dd, y h:mm:ss"
                              );

                              return (
                                <tr key={order.orderId}>
                                  <td>{order.orderId}</td>
                                  <td>{order.productInfo.fullName}</td>
                                  <td>${order.productInfo.price}</td>
                                  <td>{order.tag}</td>
                                  <td>{formattedOrderDate}</td>
                                  <td className="text-center">Processed</td>
                                  <td></td>
                                </tr>
                              );
                            })}
                          <tr className="table-info fs-4">
                            <td colSpan={7} className="text-end">
                              Total Purchase: ${totalPurchase.toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
